import { shoppingCartActionTypes } from "../../actionTypes/shoppingCart/shoppingCart.actionTypes";

// Add item to cart
export const addToCart = (item) => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.ADD_TO_CART,
    payload: item,
  });
};

// Remove item from cart
export const removeFromCart = (itemId) => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.REMOVE_FROM_CART,
    payload: itemId,
  });
};

// Update item in cart
export const updateCartItem = (item) => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.UPDATE_CART_ITEM,
    payload: item,
  });
};

// Clear the entire cart
export const clearCart = () => (dispatch) => {
  dispatch({
    type: shoppingCartActionTypes.CLEAR_CART,
  });
};



const shoppingCartActions = {
  addToCart,
  removeFromCart,
  updateCartItem,
  clearCart,
  
};

export default shoppingCartActions;
